<template>
		<div>
			<div class="d-flex align-items-center mb-3">
				<div>
					<h1 class="page-header mb-0"><i class="fas fa-bell"></i> Értesítések</h1>
				</div>
			</div>
			<panel title="Értesítések">
				<Loading v-if="notifications === false" title="értesítések betöltése"></Loading>
				<NoRecords v-if="notifications.length == 0" main_icon="fas fa-user-lock" value="false" title="Nincsenek értesítések"></NoRecords>
				<vue-good-table v-if="notifications.length != 0 && notifications !== false"
					:columns="columns" 
					:rows="notifications" 
					:lineNumbers="false"
					:search-options="{ enabled: false, placeholder: 'Keresés...' }" 
					:pagination-options="{
						enabled: true, 
						position: 'bottom',
						firstLabel : 'Első Lap',
						lastLabel : 'Utolsó Lap',
						nextLabel: 'következő',
						prevLabel: 'előző',
						rowsPerPageLabel: 'Sor oldalanként',
						ofLabel: '/',
						allLabel: 'Összes',
						infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`, 
					}"
				>
					<template slot="table-row" slot-scope="props">
						<span v-if="props.column.field == 'read_at'">
							<span v-if="props.formattedRow[props.column.field] !== null">
								{{props.formattedRow[props.column.field] | moment('YYYY-MM-DD, HH:mm')}}
							</span>
							<span v-else>
								<button @click="markAsRead(props.row.id)" class="btn btn-danger mx-1" title="olvasottként jelöl"><i class="fa fa-envelope"></i></button>
							</span>
						</span>
						<span v-else-if="props.column.field == 'created_at'">
							{{props.formattedRow[props.column.field] | moment('YYYY-MM-DD, HH:mm')}}
						</span>
						<span v-else>
							{{props.formattedRow[props.column.field]}}
						</span>
					</template>
				</vue-good-table>
			</panel>
	</div> 
</template>

<script>
	import Loading from '../../components/Loading';
	import NoRecords from '../../components/NoRecords';
	import User from '../../apis/User';

	export default {
		components: {
			Loading, NoRecords
		},
		data() {
			return {
				columns: [
					{
						label: 'Érkezett',
						field: 'created_at',
					},
					{
						label: 'Megnevezés',
						field: 'title',
					},
					{
						label: 'Elolvasva',
						field: 'read_at',
					}  
				],
				notifications: false,
				errors: [],
				loading: false,
			}
		},
		created() {
			User.notifications().then(response => {
				this.notifications = response.data;
			});
		},
		methods: {
			markAsRead(id){
				let n = this.notifications[this.notifications.findIndex(e => e.id == id)];
				if(!n.read){
					User.markAsRead(id);
					n.read = true;
					n.read_at = new Date();
				}

			}
		},
	}
</script>

<style>
	
</style>